import React from 'react'
import { shape, func, bool } from 'prop-types'
import { useSelector } from 'react-redux'
import { selectLabels } from '../../../redux/configuration/selectors'
import SvgIcon from '../../SvgIcon/SvgIcon'
import themeVariables from '../../../styles/scss/configuration/_variables.scss'

// STYLES
import './ShipNameCrossingCard.scss'
import ResourceAvailability from '../ResourceAvailability/ResourceAvailability'

const ShipNameCrossingCard = ({
  accommodationsAvailable,
  crossing,
  isCurrentlySelectedRoute,
  isDisabled,
  isOverNight,
  selectCrossing,
  vehiclesAvailable,
  petExteriorAvailable
}) => {
  const labels = useSelector(selectLabels)

  return (
    <div
      role={'button'}
      tabIndex={0}
      className={`btn ship-name-crossing-card ${
        isCurrentlySelectedRoute ? 'current-active-route' : ''
      } ${isOverNight ? 'overnight-card' : ''} ${isDisabled ? 'disabled' : ''}`}
      key={`${crossing.departureDate}-${crossing.departureTime}`}
      onClick={() => {
        if (!isDisabled) {
          selectCrossing(crossing)
        }
      }}
      onKeyDown={e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          if (!isDisabled) {
            selectCrossing(crossing)
          }
        }
      }}
    >
      <div className="header">
        <SvgIcon
          type="ship"
          fill={
            isDisabled
              ? themeVariables.themeDisabledIconColor
              : themeVariables.themeIconColor
          }
        />
      </div>

      <div className="times">
        <div className="u-flex time">
          <p>{labels.departureTime}</p>
          <p>{crossing.departureTime}</p>
        </div>
        <div className="u-flex time">
          <p>{labels.arrivalTime}</p>
          <p>{crossing.arrivalTime}</p>
        </div>
      </div>
      <ResourceAvailability
        vehiclesAvailable={vehiclesAvailable}
        accommodationsAvailable={accommodationsAvailable}
        isFlex={true}
        petExteriorAvailable={petExteriorAvailable}
      />
    </div>
  )
}

ShipNameCrossingCard.propTypes = {
  accommodationsAvailable: bool,
  crossing: shape().isRequired,
  isCurrentlySelectedRoute: bool,
  isDisabled: bool,
  isOverNight: bool,
  selectCrossing: func.isRequired,
  vehiclesAvailable: bool,
  petExteriorAvailable: bool
}

export default ShipNameCrossingCard
